import { Controller } from "@hotwired/stimulus"

// Maneja el toggle de respuestas y modo reply en comentarios.
// Targets:
//   - replies: contenedor de sub-comentarios (hidden por defecto)
//   - replyForm: formulario de reply (hidden por defecto)
//   - replyBody: textarea del reply para prefill con @nombre
//   - repliesBtn: botón "X Respuestas" para actualizar texto
export default class extends Controller {
  static targets = ["replies", "replyForm", "replyBody", "repliesBtn"]
  static values = { replyPrefix: String }

  toggleReplies() {
    if (!this.hasRepliesTarget) return
    this.repliesTarget.classList.toggle("hidden")

    // Si se ocultan las replies, también ocultar el reply form
    if (this.repliesTarget.classList.contains("hidden") && this.hasReplyFormTarget) {
      this.replyFormTarget.classList.add("hidden")
    }
  }

  toggleReply() {
    if (this.hasRepliesTarget) {
      this.repliesTarget.classList.remove("hidden")
    }
    if (this.hasReplyFormTarget) {
      const isHidden = this.replyFormTarget.classList.toggle("hidden")
      if (!isHidden) {
        const proseMirror = this.replyFormTarget.querySelector(".ProseMirror")
        if (proseMirror) {
          proseMirror.focus()
        } else if (this.hasReplyBodyTarget) {
          const prefix = this.replyPrefixValue || ""
          if (this.replyBodyTarget.value === "" || this.replyBodyTarget.value === prefix) {
            this.replyBodyTarget.value = prefix
          }
          this.replyBodyTarget.focus()
        }
      }
    }
  }
}
